import CourseContent from './CourseContent'

export default CourseContent
